import axios from "axios";
import { BASE_ENDPOINT } from "../helpers/Config";

const GIVE_RECOVERY_BONUS_URL = `${BASE_ENDPOINT}/admin/give-recovery-bonus`;
const RECOVERY_BONUS_LIST_URL = `${BASE_ENDPOINT}/admin/recovery-bonus-list`;
const RECOVERY_TRADE_HISTORY_URL = `${BASE_ENDPOINT}/admin/recovery-trade-history`;

/**
 * POST /recovery-trade/give-recovery-bonus
 * @param {{ token: string; crypto: string; lite: number; plus: number; pro: number; max: number }} payload
 */
export async function giveRecoveryBonus(payload) {
    const res = await axios({
        method: "post",
        url: GIVE_RECOVERY_BONUS_URL,
        headers: { "Content-Type": "application/json" },
        data: payload,
        timeout: 60000,
    });
    return res?.data;
}

/**
 * POST /admin/recovery-bonus-list
 * @param {{ token: string; page_no: number; limit: number }} payload
 */
export async function fetchRecoveryBonusList(payload) {
    const res = await axios({
        method: "post",
        url: RECOVERY_BONUS_LIST_URL,
        headers: { "Content-Type": "application/json" },
        data: payload,
        timeout: 30000,
    });
    return res?.data;
}

/**
 * POST /admin/recovery-trade-history
 * @param {{ token: string; search?: string; page_no?: number; limit?: number }} payload
 */
export async function fetchRecoveryTradeHistory(payload) {
    const res = await axios({
        method: "post",
        url: RECOVERY_TRADE_HISTORY_URL,
        headers: { "Content-Type": "application/json" },
        data: {
            token: payload.token,
            search: payload.search ?? "",
            page_no: payload.page_no ?? 1,
            limit: Math.min(100, Math.max(1, payload.limit ?? 20)),
        },
        timeout: 30000,
    });
    return res?.data;
}
